import ServicesManager from "./userManageComponents/ServicesManager";
import { Divider } from "../mui";
import { HeaderText } from "../components/Text/HeaderText";
import { QueryClient, QueryClientProvider } from "react-query";
import UIWrapper from "../components/UIWrapper";
import { Auth } from "aws-amplify";
const queryClient = new QueryClient();

function UserAppManager(props) {
  return (
    <>
      <UIWrapper title="User Management" paper>
        <QueryClientProvider client={queryClient}>
          <ServicesManager service={props.service} />
        </QueryClientProvider>
      </UIWrapper>
    </>
  );
}

export default UserAppManager;
